import { format } from 'date-fns'

// URLパラメータから時刻を解析するヘルパー関数 (HHmm形式)
export function parseTimeParam(
  timeStr: string | null,
  dateStr: string
): Date | null {
  if (!timeStr) return null
  const match = timeStr.match(/^(\d{2})(\d{2})$/)
  if (!match) return null
  const [, hours, minutes] = match
  const date = new Date(dateStr)
  date.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0)
  return date
}

// 時刻をHHmm形式にフォーマットするヘルパー関数
export function formatTimeForUrl(date: Date): string {
  return format(date, 'HHmm')
}

// URLパラメータから日付を解析するヘルパー関数 (YYYYMMDD形式)
export function parseDateParam(dateStr: string | null): string | null {
  if (!dateStr) return null
  const match = dateStr.match(/^(\d{4})(\d{2})(\d{2})$/)
  if (!match) return null
  const [, year, month, day] = match
  return `${year}-${month}-${day}`
}

// 日付をYYYYMMDD形式にフォーマットするヘルパー関数
export function formatDateForUrl(dateStr: string): string {
  return dateStr.replace(/-/g, '')
}
